<template>
  <!--  <b-container fluid="true" class="itemContainer">-->
  <!--    <div class="itemHeader">-->
  <!--      <b-row>-->
  <!--        <p class="pkgNameText">{{ item.image }}</p>-->
  <!--      </b-row>-->
  <!--    </div>-->
  <!--    <div class="itemOverlay container">-->
  <!--      <b-row class="descTextRow">-->
  <!--        <p class="descText">{{ item.title }}</p>-->
  <!--      </b-row>-->
  <!--      <b-row class="descTextRow">-->
  <!--        <p class="descText">{{ item.desc }}</p>-->
  <!--      </b-row>-->
  <!--    </div>-->
  <!--  </b-container>-->
  <div ref="top">
    <div class="itemContainer">
      <div class="itemThumb">
        <img :src="item.image" alt="" @load="onLoaded" />
      </div>
      <div class="rowSpace"></div>
      <div class="itemTitle">
        {{ item.title }}
      </div>
      <div class="rowSpace"></div>
      <div class="itemLine"><hr /></div>
      <div class="rowSpace"></div>
      <div class="itemDesc">
        {{ item.desc }}
      </div>
      <div class="rowSpace"></div>
      <div class="buttonGroup">
        <button class="moveButton" @click="goLink(item.url)">
          <span>{{ $t('main_facility_link') }}</span>
          <b-icon icon="chevron-right" font-scale="1" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FacilityItem',
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      imageLoaded: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      console.log('HEIGHT>>>!!!0-CHILD');
    });
  },
  methods: {
    onLoaded() {
      this.imageLoaded = true;
      console.log('HEIGHT>>>!!!0-CHILD-ONLOAD', this.$refs.top.clientHeight, this.imageLoaded);
      this.$emit('ImgLoaded');
    },

    goLink(url) {
      console.log('go');
      this.$router.push('p/' + url);
    },
  },
};
</script>

<style scoped lang="scss">
@mixin ellipsis($line-cnt, $line-height) {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: $line-cnt; /* 라인수 */
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  word-break: normal;
  line-height: $line-height;
  height: ($line-height * $line-cnt); /* line-height 가 1.2em 이고 3라인을 자르기 때문에 height는 1.2em * 3 = 3.6em */
}
.itemContainer {
  //  border: 1px solid #e2e2e2;
}
.itemThumb {
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.rowSpace {
  height: 1rem;
}
.itemTitle {
  text-align: left;
  font: normal normal 600 1.4rem Segoe UI;
  letter-spacing: -0.05rem;
  color: #393939;
  opacity: 1;
}
.itemLine {
  width: 3rem;
  hr {
    border-bottom: 1px solid #bababa;
    margin: 0px;
  }
}
.itemDesc {
  height: 2.5rem;
  text-align: left;
  font: normal normal 500 0.9rem Segoe UI;
  letter-spacing: 0px;
  color: #363636;
  opacity: 1;
  word-break: keep-all;
}
.buttonGroup {
  display: flex;
  width: 100%;
  justify-content: right;
  bottom: 0px;
  .moveButton {
    display: flex;
    align-items: center;
    justify-content: right;
    //height: 3rem;
    font-size: 0.8rem;
    font-weight: 600;
    width: 40%;
    background-color: white !important;
    padding: 0px !important;
    color: black;
    border: none;
    outline: none;
    span {
      padding: 0px;
      text-align: center;
      padding: 0px !important;
    }
    &:hover {
      //background-color: #403a30 !important;
    }
  }
}

//
//.itemHeader {
//  position: absolute;
//  right: 0;
//  background-image: url('~@/assets/images/img_bg_black_50.png');
//  width: 40%;
//  height: 10%;
//  margin-bottom: 0%;
//}
//
//.pkgNameText {
//  position: absolute;
//  text-align: center;
//  color: white;
//  font-size: 0.8em;
//  font-weight: bold;
//  white-space: nowrap;
//  top: 50%;
//  left: 50%;
//  transform: translate(-50%, -50%);
//  -webkit-transform: translate(-50%, -50%);
//}
//
//.itemOverlay {
//  position: absolute;
//  bottom: 0px;
//  /*background-color: black;*/
//  width: 100%;
//  height: auto;
//  /*opacity: 0.5;*/
//  margin-bottom: 0%;
//  background-image: url('~@/assets/images/img_bg_black_50.png');
//}
//
//.itemTitleRow {
//  padding-left: 30px;
//  padding-top: 40px;
//  padding-right: 30px;
//  padding-bottom: 10px;
//}
//
//.itemTitle {
//  @include ellipsis(1, 1em);
//
//  position: relative;
//  color: white;
//  font-weight: bold;
//  //font-size: 1.1em;
//}
//
//.itemSchedule {
//  padding-left: 30px;
//  padding-top: 5px;
//  padding-right: 30px;
//  padding-bottom: 10px;
//  color: white;
//  font-size: 0.8em;
//  overflow: hidden;
//  text-overflow: ellipsis;
//  white-space: normal;
//}
//
//.descTextRow {
//  padding-left: 30px;
//  padding-top: 10px;
//  padding-right: 30px;
//  padding-bottom: 40px;
//}
//
//.descText {
//  @include ellipsis(3, 1.6em);
//  color: white;
//  font-size: 0.8em;
//}
//
//.btnRow {
//  padding-left: 20px;
//  padding-top: 0px;
//  padding-right: 20px;
//  padding-bottom: 20px;
//  padding-left: 0px !important;
//  padding-right: 0px !important;
//}
//
//.btm-btn-1 {
//  border: 1px solid #ffffff !important;
//  color: #ffffff !important;
//  background-color: transparent;
//}
//
//.btm-btn-1:hover {
//  color: black !important;
//  background-color: red !important;
//  box-shadow: none;
//}
//
//.btm-btn-2 {
//  border: 1px solid #000000 !important;
//  color: #ffffff !important;
//  background-color: #000000;
//}
//
//.btm-btn-2:hover {
//  color: black !important;
//  background-color: red !important;
//  box-shadow: none;
//}
</style>

<i18n>
{
  "ko": {
    "main_facility_link": "바로가기"
  },
  "en": {
    "main_facility_link": "Site link"
  },
  "ja": {
    "main_facility_link": "サイトに移動"
  }
}
</i18n>
